export default __webpack_public_path__ + "static/media/mauka.75b7eb5d.png";